import React from 'react';
import InfoCards from "../../../../components/charts/infoCards";
import {useLotCount, useProjectCount, useTransactionCount} from "../hooks";

export default function PaymentInfoCards() {
    const {data: projectCountData, isLoading: projectCountLoading} = useProjectCount()
    // const {data: lotCountData, isLoading: lotCountLoading} = useLotCount()
    const {data: transactionCountData, isLoading: transactionCountLoading} = useTransactionCount()

    return (
        <InfoCards data={[
            {
                label: "Transactions",
                value: transactionCountData?.count,
                color: "green2",
                isLoading: transactionCountLoading,
                navigateTo: 'transactions'
            },
            {
                label: "Projects",
                value: projectCountData?.count,
                color: "blue2",
                isLoading: projectCountLoading,
                navigateTo: 'projects'
            },
            // {
            //     label: "Lots",
            //     value: lotCountData?.count,
            //     color: "primary",
            //     isLoading: lotCountLoading,
            //     navigateTo: 'lots'
            // }
        ]}/>
    )
}